import { render, staticRenderFns } from "./Insert.vue?vue&type=template&id=3bfbb1c0"
import script from "./Insert.vue?vue&type=script&lang=js"
export * from "./Insert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports